import { PasswordInput, PasswordInputProps } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface PasswordFieldProps
  extends FieldType,
    Omit<PasswordInputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {}

/**
 * PhoneField.
 */
export const PasswordField = ({
  name,
  allowSubmit,
  onBlur,
  ...props
}: PasswordFieldProps) => {
  const { field, helpers, inputProps } = useField<string | undefined>(name, {
    allowSubmit,
  });

  return (
    <PasswordInput
      {...props}
      name={name}
      value={field.value ?? ''}
      onBlur={(event) => {
        onBlur?.(event);
        field.onBlur(name)(event);
      }}
      onChange={() => helpers.setError(undefined)}
      onChangeText={(v) => helpers.setValue(v)}
      {...inputProps}
    />
  );
};
